import LoginIcon from "@mui/icons-material/Login"
import LogoutIcon from "@mui/icons-material/Logout"
import { Box, Stack, SwipeableDrawer, Typography } from "@mui/material"
import { ReactElement } from "react"
import { useNavigate } from "react-router-dom"

import { SIDE_BAR_NON_MOBILE_WIDTH } from "../../../constants/generalConstants"
import { useGetUserData } from "../../../hooks/useGetUserData"
import { useScreenSize } from "../../../hooks/useScreenSize"
import { BASE_URL, LOGIN } from "../../../router/routes"
import { container } from "../../../themes/baseTheme"
import AppButton from "../../buttons/appButton"
import DisplayIf from "../../wrappers/displayIf"
import ExpandedVerticalNavOptions from "../navBar/navBarVerticalExpandedOptions"
import { navOptionsByGroup } from "../navOptions"

interface IPreferencesSidebarProps {
    isOpen: boolean
    setIsOpen: (isOpen: boolean) => void
}

const MobileNavSideBar = ({
    isOpen,
    setIsOpen,
}: IPreferencesSidebarProps): ReactElement => {
    const { isMob } = useScreenSize()
    const navigate = useNavigate()

    const { groups, onSignOut, isSignedIn } = useGetUserData()

    return (
        <SwipeableDrawer
            anchor="right"
            open={isOpen}
            onClose={() => setIsOpen(false)}
            onOpen={() => ({})}
            ModalProps={{
                container: container(),
            }}
        >
            <Box
                width={isMob ? "100vw" : SIDE_BAR_NON_MOBILE_WIDTH}
                sx={{
                    backgroundColor: "background.contentBackground",
                    overflowY: "auto",
                    height: "100%",
                }}
            >
                <Stack
                    padding={4}
                    sx={{
                        backgroundColor: "background.contentBackground",
                    }}
                >
                    <Typography
                        fontWeight="bold"
                        gutterBottom
                        variant="h5"
                        component="div"
                        color="primary"
                        marginBottom={1}
                    >
                        Where do you want to go?
                    </Typography>
                    <Typography marginBottom={3} component="div">
                        Use this menu to find your way around the app. By the
                        way, you can swipe right to close this sidebar
                    </Typography>
                    <ExpandedVerticalNavOptions
                        groups={navOptionsByGroup(groups).groupOrder}
                        options={navOptionsByGroup(groups).options}
                        onClickSideEffect={() => setIsOpen(false)}
                    />
                    <Stack
                        direction="row"
                        justifyContent="center"
                        marginTop={2}
                    >
                        <DisplayIf condition={isSignedIn}>
                            <AppButton
                                variant="outlined"
                                endIcon={<LogoutIcon />}
                                onClick={() => {
                                    onSignOut()
                                    navigate(BASE_URL)
                                    setIsOpen(false)
                                }}
                            >
                                Log Out
                            </AppButton>
                        </DisplayIf>
                        <DisplayIf condition={!isSignedIn}>
                            <AppButton
                                variant="outlined"
                                endIcon={<LoginIcon />}
                                onClick={() => {
                                    navigate(LOGIN)
                                    setIsOpen(false)
                                }}
                            >
                                Sign Up / In
                            </AppButton>
                        </DisplayIf>
                    </Stack>
                </Stack>
            </Box>
        </SwipeableDrawer>
    )
}

export default MobileNavSideBar
